import React, { useState } from "react";
import "./LimitedEdition.css";
import { useDispatch, useSelector } from "react-redux";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import FavoriteButton from "../../Favourite_button/favourite_button";
import { Navigation } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import CircleLoading from "../../CirculusIndicator/CircleLoading";

const LimitedEdition = () => {
  const dispatch = useDispatch();
  const { limitedEdition, status } = useSelector((state) => state.home);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="limitedProductSection">
        <h2>
          Limited <span>Edition</span>
        </h2>
        {status === "loading" ? <div
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            ><CircleLoading /></div>  : <div className="limitedProductSlider">
          <div className="swiper-button image-swiper-button-next">
            <IoIosArrowForward />
          </div>
          <div className="swiper-button image-swiper-button-prev">
            <IoIosArrowBack />
          </div>
          <Swiper
            slidesPerView={4}
            slidesPerGroup={4}
            spaceBetween={30}
            loop={true}
            navigation={{
              nextEl: ".image-swiper-button-next",
              prevEl: ".image-swiper-button-prev",
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              320: {
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 14,
              },
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 30,
              },
            }}
          >
            {limitedEdition.map((product) => {
              return (
                <SwiperSlide key={product.productId}>
                  <div className="lpContainer">
                    <div className="lpImageContainer">
                      <Link to={`/product/${product.productId}`} state={{ product }} onClick={scrollToTop}>
                        <img
                          src={product.images[0]}
                          alt={product.images[1]}
                          className="lpImage"
                        />
                      </Link>
                    </div>
                    <div className="limitedProductInfo">
                      <div className="lpCategoryWishlist">
                        <p>{product.category}</p>
                        <FavoriteButton productId={product.productId} />
                      </div>
                      <div className="productNameInfo">
                        <Link to={`/product/${product.productId}`} state={{ product }} onClick={scrollToTop}>
                          <h5>{product.title}</h5>
                        </Link>
                        <p>
                          {product.hasDiscount ? (
                            <>
                              <span style={{ textDecoration: "line-through", color: "gray", marginRight: "5px" }}>
                                Rs.{product.price}
                              </span>
                              <span style={{ color: "black" }}>Rs.{product.discountPrice}</span>
                            </>
                          ) : (
                            <span>Rs.{product.price}</span>
                          )}
                        </p>
                        <div className="productRatingReviews">
                          <div className="productRatingStar">
                            {Array.from({ length: 5 }).map((_, index) => {
                              const rating = product.totalRating / product.totalPeopleReview || 0;
                              const fullStars = Math.floor(rating);
                              const hasHalfStar = rating - fullStars >= 0.5;
                              if (index < fullStars) return <FaStar key={index} color="#FEC78A" size={14} />;
                              else if (index === fullStars && hasHalfStar) return <FaStarHalfAlt key={index} color="#FEC78A" size={14} />;
                              else return <FaRegStar key={index} color="#FEC78A" size={14} />;
                            })}
                          </div>

                          <span>{product.totalPeopleReview}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>}

      </div>
    </>
  );
};

export default LimitedEdition;
